import { realBricksApi } from '../../utils/axiosInterceptors';

export const getInitialOffering = async (data) => {
  const response = await realBricksApi.get(`/api/v1/properties/primary?page=${data.page}&perPage=${data.perPage}`);
  return response.data;
};

export const getAccountBalances = async () => {
  const response = await realBricksApi.get(`/api/v1/user/account-balances`);
  return response.data;
}

export const placeBuyOrder = async (data) => {
  const response = await realBricksApi.post(`/api/v1/payment/primary-buy-order`, data);
  return response.data;
};

export const getAgreement = async (propertyId) => {
  const response = await realBricksApi.get(`/api/v1/properties/agreement/${propertyId}`);
  return response.data;
}

export const processPlaceOrder = async (orderId) => {
  const response = await realBricksApi.put(`/api/v1/properties/process-placed-order/${orderId}`);
  return response.data;
}

export const getInitialOfferingData = async (data, { rejectWithValue }) => {
  const { page, perPage, locationString, savedProperty, ownProperty, dividendPaidProperty, propertyTypeString, leverageString, priceRange, sortType, marketPlaceSearch, onFail = () => {} } = data;
  try {
    const response = await realBricksApi.get(`/api/v1/properties/primary?page=${page}&perPage=${perPage}${locationString && locationString !== '' ? `&${locationString}` : ''}${propertyTypeString && propertyTypeString !== '' ? `&${propertyTypeString}` : ''}${leverageString && leverageString !== '' ? `&${leverageString}` : ''}${savedProperty ? `&savedProperties=${savedProperty ? '1' : '0'}` : ''}${ownProperty ? `&ownedProperties=${ownProperty ? '1' : '0'}` : ''}${dividendPaidProperty ? `&dividendPayingProperties=${dividendPaidProperty ? '1' : '0'}` : ''}${priceRange && priceRange?.length > 0 ? `&minSharePrice=${priceRange[0]}` : ''}${priceRange && priceRange?.length > 0 ? `&maxSharePrice=${priceRange[1]}` : ''}${sortType && sortType !== '' ? `&sort=${sortType}` : ''}${marketPlaceSearch && marketPlaceSearch !== '' ? `&search=${marketPlaceSearch}` : ''}`);
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};

export const cancelBuyOrder = async (data, { rejectWithValue }) => {
  const { id, onFail = () => {} } = data;
  try {
    const response = await realBricksApi.post(`/api/v1/payment/cancel-primary-buy-order/${id}`);
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};

